<template>
  <div class="top_nav">
    <img alt="" class="logo" src="../assets/image/logo.png">
    <div class="menu_ul">
      <div class="menu_list">
        <div v-for="item in menuList" :key="item.id" :class="{ 'sel_menu': currentMenuId === item.id }"
             class="menu_item" @click="menuClick(item)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="display_flex t_r">
      <el-autocomplete
          v-model="keyword"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          class="inline-input"
          placeholder="请输入关键字搜索"
          @select="handleSelect"
      >
        <el-select slot="prepend" v-model="select" placeholder="请选择" @change="typeSelect">
          <el-option label="体育资讯" value="1"></el-option>
          <el-option label="场馆预定" value="2"></el-option>
          <el-option label="赛事报名" value="3"></el-option>
        </el-select>
      </el-autocomplete>
      <!--      <el-input placeholder="请输入关键字搜索" style="max-width: 257px" suffix-icon="el-icon-search"></el-input>-->
      <el-button v-if="!isLogin" style="margin-left: 39px" type="primary" @click="toLogin(1)">登录</el-button>
      <el-button v-if="isLogin" style="margin-left: 39px" type="primary" @click="toMineCenter()">个人中心</el-button>
      <el-button v-if="isLogin" @click="loginOut()">退出登录</el-button>
      <el-button v-if="!isLogin" @click="toLogin(0)">注册</el-button>
    </div>
  </div>
</template>

<script>
import { getToken, removeToken } from "../utils/auth";
import { post } from "../utils/request";

export default {
  name: "topNav",
  data () {
    return {
      isLogin: false,
      menuList: [
        { id: 1, name: '首页', path: '/' },
        { id: 2, name: '体育资讯', path: '/sportsInformation' },
        { id: 3, name: '健身地图', path: '/fitnessMap' },
        { id: 7, name: '赛事地图', path: '/eventMap' },
        { id: 4, name: '场馆预定', path: '/venueReservation' },
        { id: 5, name: '赛事报名', path: '/eventActivities' },
        { id: 6, name: '科学健身指导', url: 'https://www.js365.org.cn/pages/science/index?id=266184904588267520' }
      ],
      currentMenuId: 1,
      restaurants: [],
      keyword: '',
      select: null
    }
  },
  mounted () {
    this.currentMenuId = this.$route.meta.navId
    this.initUserData()
  },
  methods: {
    async typeSelect (val) {
      this.selectIndex = val
      this.keyword = ''
    },

    // 新闻
    getPage () {
      return new Promise((resolve) => {
        this.$postAction('gateway/health-counseling/getPage', {
          "page": {
            "current": 1,
            "size": 50
          },
          "data": {
            "type": null,
            "keyword": this.keyword
          }
        }).then((res) => {
          let data = res.data.records
          let arr = []
          data.forEach((val) => {
            arr.push({
              value: val.title,
              ...val
            })
          })
          resolve(arr)
        })
      })
    },

    // 场馆
    menhuAjax () {
      return new Promise((resolve) => {
        this.$postAction('gateway/venue-table/menhu_page', {
          "page": {
            "current": 1,
            "size": 500
          },
          "data": {
            "cityId": null,
            "areaId": null,
            "projectId": 0,
            "name": this.keyword
          }
        }).then((res) => {
          let data = res.data.records
          let arr = []
          data.forEach((val) => {
            arr.push({
              value: val.name,
              ...val
            })
          })
          resolve(arr)
        })
      })
    },

    // 热门赛事
    getManagementPage () {
      return new Promise((resolve) => {
        this.$postAction('gateway/event-management/getManagementPage', {
          "page": {
            "current": 1,
            "size": 500
          },
          "data": {
            "type": 0,
            "keyword": this.keyword
          }
        }).then((res) => {
          let data = res.data.records
          let arr = []
          data.forEach((val) => {
            arr.push({
              value: val.name,
              ...val
            })
          })
          resolve(arr)
        })
      })
    },

    async querySearch (queryString, cb) {
      switch (this.selectIndex) {
        case '1':
          this.restaurants = await this.getPage()
          break;
        case '2':
          this.restaurants = await this.menhuAjax()
          break;
        case '3':
          this.restaurants = await this.getManagementPage()
          break;
      }
      // 调用 callback 返回建议列表的数据
      cb(this.restaurants);
    },

    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    handleSelect (item) {
      switch (this.selectIndex) {
        case '1':
          this.$router.push({
            path: '/sportsDetails',
            query: {
              item: JSON.stringify(item)
            }
          })
          break;
        case '2':
          this.$router.push({
            path: '/venueDetail',
            query: {
              id: item.id
            }
          })
          break;
        case '3':
          this.$router.push({
            path: '/eventDetails',
            query: {
              item: JSON.stringify(item)
            }
          })
          break;
      }
    },

    loginOut () {
      removeToken()
      this.$router.replace('/login')
    },

    toMineCenter () {
      this.$router.push('/mineCenter')
    },

    initUserData () {
      let token = getToken()
      if (token) {
        post('/gateway/getAppUserInfo').then(res => {
          this.isLogin = true
        })
      }
    },

    toLogin (type) {
      this.$router.push({ path: '/login', query: { type: type } })
    },

    menuClick (item) {
      if (!item.path && !item.url) {
        return
      }
      if (item.url) {
        window.open(item.url)
        return;
      }
      this.$router.push(item.path)
    }
  }
}
</script>

<style lang="less" scoped>
.top_nav {
  padding: 19px 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  position: sticky;
  top: 0;
  z-index: 999;

  .logo {
    width: 30%;
    max-width: 374px;
  }

  .menu_ul {
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    height: 70px;
    display: flex;
    align-items: center;
    margin-left: 5%;
    margin-right: 5%;
  }

  .menu_list {
    width: 100%;
    height: 25px;
    font-size: 20px;
    color: #0058A6;
    display: flex;

    .menu_item {
      margin-right: 5%;
      position: relative;
      cursor: pointer;
      white-space: nowrap;

      &:hover {
        text-shadow: 1px 1px 2px rgba(28, 133, 246, .2);

      }

    }

    .sel_menu {
      font-weight: 700;

      &::before {
        content: '';
        position: absolute;
        width: 55px;
        height: 4px;
        background: #0058A6;
        border-radius: 2px;
        bottom: -18px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .t_r {
    justify-content: right;
    //flex: 1;
  }
}

::v-deep .el-select .el-input {
  width: 110px;
}

::v-deep .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
